<div class="container m-5">
    <h2>¡Bienvenido a LevelApp!</h2>
    <h4>Le aplicación para llevar tu <strong>negocio</strong> al siguiente <strong>nivel.</strong></h4>
    <p>Somos una aplicación que ofrece ayudarte a <span>organizar mejor tu negocio</span>.</p>
    <p>Cómo organizar tus <strong>ventas y egresos</strong>, cómo tener una <strong>lista de precios</strong> de
        productos ordenada, <br>
        cómo llevar el <strong>balance de mi negocio</strong> y más ya no será problema.</p>
    <hr>
    <p>En el menú de tu izquierda, si estás desde una PC, o en el menú desplegable, si estás desde una<br>
        tablet o teléfono, podrás navegar por las distintas opciones que tienes para gestionar tu comercio.</p>

</div>